const TipoInsumoPrioridade = Object.freeze({
  ALTA: 'Alta',
  MEDIA: 'Média',
  BAIXA: 'Baixa'
});

export default TipoInsumoPrioridade;
